/** Items that are cleared from session storage when an order is completed or discarded */
export const CBookingStorageKeys = {
  order: 'order',
  bookingTimerId: 'bookingTimerId',
  draftBooking: 'draft',
  extendDialogTimerStarted: 'extendDialogTimerStarted',
  paymentJwt: 'paymentJwt',
  timerStarted: 'timerStarted',
  isTermsAccepted: 'isTermsAccepted',
  guestCount: 'guestCount'
};

/** Items that usually remain in storage during the apps lifecycle */
export const CStorageKeys = {
  ...CBookingStorageKeys,
  apiKey: 'X-Api-Key',
  cellId: 'X-Cell-Id',
  originId: 'X-Origin-Id',
  checkout: 'X-Checkout',
  api: 'api',
  accountDetails: 'guestDetails',
  auth: 'authorization',
  /** of type IConsent[] */
  consent: 'consent',
  redirectNeeded: 'redirectNeeded',
  autoCreateAccount: 'autoCreateAccount',
  abTesting: 'abTesting'
};
